export default __webpack_public_path__ + "static/media/Willcaster Circlet.00f5f15d.jpg";